import { IEventPauseUpdateParams } from '../../services/Events/types';
import ButtonComponent from '../ButtonComponent';
import { Pause, PlayArrow } from '@mui/icons-material';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { Box } from '@mui/material';
import { t } from 'i18next';

interface IPauseButtonProps {
  pausedUpdateParams: IEventPauseUpdateParams;
  setPausedUpdateParams: Dispatch<SetStateAction<IEventPauseUpdateParams>>;
}

const PauseButtonComponent = ({
  pausedUpdateParams,
  setPausedUpdateParams,
}: IPauseButtonProps) => {
  const setIsPaused = (isPaused: boolean) => {
    setPausedUpdateParams({ ...pausedUpdateParams, isPaused: isPaused });
  };

  useEffect(() => {
    if (!pausedUpdateParams.isPaused) {
      pausedUpdateParams.clearCacheData();
    }
  }, [pausedUpdateParams.isPaused]);

  return (
    <Box>
      {pausedUpdateParams.isPaused ? (
        <ButtonComponent
          size={'small'}
          color={'error'}
          startIcon={<PlayArrow />}
          onClick={() => setIsPaused(false)}
        >
          {t('pauseButtonComponent.startUpdates')}
        </ButtonComponent>
      ) : (
        <ButtonComponent
          size={'small'}
          color={'primary'}
          startIcon={<Pause />}
          onClick={() => setIsPaused(true)}
        >
          {t('pauseButtonComponent.pauseUpdates')}
        </ButtonComponent>
      )}
    </Box>
  );
};

export default PauseButtonComponent;
